import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Page } from '../../../shared/models/page';
import { EnvironmentConfiguration } from '../../../environment/services/environment.configuration';
import { Router } from '@angular/router';
import { MatchingAgencyService } from '../../../shared/matching-agency/matching-agency.service';
import { MatchingAgency } from '../../models/matching-agency';

@Component({
  selector: 'pioneer-matching-agency-list',
  templateUrl: './matching-agency-list.component.html',
  styles: []
})
export class MatchingAgencyListComponent implements OnInit {

  @Input()
  agencies: Page<MatchingAgency>;

  @Input()
  currentPage: number;

  @Output()
  public sortPage: EventEmitter< {field: string, direction: string} > = new EventEmitter< {field: string, direction: string} >();

  constructor(
    private environment: EnvironmentConfiguration,
    private matchingAgencyService: MatchingAgencyService,
    private router: Router) {
  }

  ngOnInit() {
  }

  get agencyCount(): number {
    return this.agencies.totalElements;
  }

  selectAgency(agency: MatchingAgency): void {
    this.matchingAgencyService.setSelectedAgency(agency);
    this.matchingAgencyService.setSelectedPage(this.currentPage);
    this.router.navigate([ '/events/matching/agency/candidates' ], {
    });
  }

  sortList(field: string, direction: string) {
    this.sortPage.emit( { field: field, direction: direction } );
  }

}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/matching-agency/matching-agency-list/matching-agency-list.component.ts